import { ConfigurationEnumsService_enumsServiceGetGetEnum } from '@festina/datamart2-general-types/datamart2/hooks/ConfigurationEnumsService_enumsServiceGetGetEnum'

export const useFetchEnumValues =
  ConfigurationEnumsService_enumsServiceGetGetEnum.useSuspenseQuery
